import { render, staticRenderFns } from "./FirmaUsuario.vue?vue&type=template&id=6b96c82c&scoped=true&"
import script from "./FirmaUsuario.vue?vue&type=script&lang=js&"
export * from "./FirmaUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b96c82c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/FirmaUsuario.vue
// module id = 635
// module chunks = 3